"use client";
import { Dialog, DialogTrigger } from "@radix-ui/react-dialog";
import { DialogContent, DialogHeader, DialogTitle } from "./dialog";
import { Share2 } from "lucide-react";
import {
  QuranWbwIndoPak15ResponseType,
  QuranWbwIndoPak16ResponseType,
  QuranWbwUthmaniResponseType,
} from "@/lib/types";
import { useEffect, useRef, useState } from "react";
import { getWordsWithSameRoot, WbwRootType } from "@/actions/get-root-words";
import useWbwTranslations from "@/lib/hooks/useWbwTranslation";
import QuranRootOrSameWordsTable from "./quran-root-or-same-words-table";
import { ScrollArea } from "./scroll-area";
import { Spinner } from "./spinner";

export default function QuranRootWordsView({
  word,
}: {
  word:
    | QuranWbwUthmaniResponseType
    | QuranWbwIndoPak16ResponseType
    | QuranWbwIndoPak15ResponseType;
}) {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<null | WbwRootType[]>(null);
  const isFetching = useRef(false);

  const { wordTranslation } = useWbwTranslations(
    parseInt(word.id.toString()),
    word.page,
  );

  useEffect(() => {
    if (!wordTranslation) return;
    if (data && isFetching.current) return;

    isFetching.current = true;
    const fetchRootWords = async () => {
      const resp = await fetch(
        `/api/get-words?type=root&word=${wordTranslation.root}`,
      );
      const result = await resp.json();
      // const result = await getWordsWithSameRoot(wordTranslation.root);
      if (result.success) {
        setLoading(false);
        setData(result.result);
      } else console.log("error: ", result.error);

      isFetching.current = false;
    };

    fetchRootWords();
  }, [wordTranslation]);

  return (
    <Dialog>
      <DialogTrigger asChild className="w-full">
        <div className="hover:bg-primary/20 rounded-md p-[.4rem] cursor-default flex flex-row">
          <span className="pr-2">
            <Share2 className="w-5 h-5 text-primary" />
          </span>
          <span className="relative  text-text">Words with same root</span>
        </div>
      </DialogTrigger>
      <DialogContent className="min-w-11/12 md:min-w-4xl max-h-11/12 rounded-lg overflow-hidden p-0">
        <div className="bg-primary/15 dialog-test-class p-8">
          <DialogHeader className="p-5">
            <DialogTitle className="text-center">
              Words with same root
            </DialogTitle>
          </DialogHeader>
          {loading && (
            <div className="h-30 text-center flex items-center justify-center">
              <Spinner className="text-primary" size={"large"}>
                <span>Loading......</span>
              </Spinner>
            </div>
          )}

          {!loading && (
            <div>
              <div className="overflow-hidden">
                <ScrollArea className="h-[35rem] md:h-[50rem] overflow-hidden">
                  {data && (
                    <QuranRootOrSameWordsTable
                      tableHeadData={{
                        head1: "Word",
                        head2: "Surah",
                        head3: "Verse",
                      }}
                      tableBodyData={data}
                    />
                  )}
                </ScrollArea>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
